import {
  mapState,
  mapMutations
} from 'vuex'
import '../css/login.css'
import api from '../service/services.js'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.min.css'
import swal from 'sweetalert2/dist/sweetalert2.js'
import 'sweetalert2/src/sweetalert2.scss'

export default {
  data () {
    return {
      username: '',
      password: '',
      screenHeight: window.innerHeight,
      isLoading: false
    }
  },
  components: {
    Loading
  },
  computed: {
    ...mapState(['user', 'url', 'config']),
    ...mapMutations(['sigin', 'setConfig'])
  },
  methods: {
    login () {
      this.isLoading = true
      api.AXlogin(
        this.url, {
          username: this.username,
          password: this.password
        },
        result => {
          if (result.status === 1) {
            this.$store.commit('sigin', {
              username: this.username,
              role_name: result.data.role_name,
              accesstoken: result.data.accesstoken
            })
            window.location = '/'
          } else {
            swal(
              'LOG IN Error!!',
              result.data,
              'error'
            )
          }
          this.isLoading = false
        },
        error => {
          this.isLoading = false
          alert(JSON.stringify(error))
        }
      )
    },
    getConfig () {
      api.AXconfig(this.url,
        result => {
          if (result.status === 1) {
            this.$store.commit('setConfig', {
              config: result.data[0]
            })
          } else {
            swal(
              'GET CONFIG Error!!',
              result.data,
              'error'
            )
          }
          this.isLoading = false
        },
        error => {
          this.isLoading = false
          alert(JSON.stringify(error))
        }
      )
    }
  },
  mounted () {
    document.getElementById('user').focus()
    this.getConfig()
    if (this.user.username !== null) {
      this.$router.push({
        name: 'Home'
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/js/login.js